module.exports = __webpack_public_path__ + "assets/img/5.4ffebc61.jpg";